"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffiliationMatches = exports.getAffiliationConfig = void 0;
const defJSON = require("../definitions/affiliations-defs.json");
function getAffiliationConfig() {
    return defJSON;
}
exports.getAffiliationConfig = getAffiliationConfig;
function getAffiliationMatches() {
    let affTypes = [];
    for (let aff of defJSON) {
        let type = affTypes.find(type => type.name === aff.From);
        if (!type) {
            type = {
                name: aff.From,
                affiliations: new Set()
            };
            affTypes.push(type);
        }
        type.affiliations.add(aff.To);
    }
    return affTypes;
}
exports.getAffiliationMatches = getAffiliationMatches;
